
define('text!ui/main.html',[],function () { return '<!-- ko if: shellName --><div class="shell" data-bind="component: { name: shellName }"></div><!-- /ko -->';});

